"use-strict";

import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import { Link } from "react-router-dom";

export default class Courses extends Component {
  render() {
    return (
      <div className="bounds">
        <div
          className="grid-100"
          style={{
            textAlign: "center",
            marginTop: "12%",
            marginLeft: "0%",
            width: "100%",
          }}
        >
          <span
            style={{
              backgroundColor: "#3D3D3D",
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0%",
              zIndex: -1,
              top: "90px",
              opacity: "75%",
            }}
          ></span>

          <img
            src={
              "https://media3.giphy.com/media/r0LaehSESRcu6KWcjX/giphy.gif?cid=790b76116425057565f8187aa96abeccd0b0266838e91d25&rid=giphy.gif&ct=g"
            }
            alt="hope"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0%",
              zIndex: -2,
              top: "90px",
            }}
          ></img>
          <div
            style={{
              textAlign: "center",
              width: "100%",
              position: "absolute",
              alignItems: "center",
              top: "20%",
              zIndex: -1,
            }}
          >
            <span
              style={{
                position: "absolute",
                top: "20%",
                zIndex: 3,
                width: "100%",
                right: "0%",
              }}
            >
              <h1
                className="obs text-warning"
              >
                FitnessObsession
              </h1>
              <p
                className="bio text-warning"
                
              >
                Find all the best Rated items online over 1000 reviews on each
                item.
              </p>
              <p
                className="bio text-warning"
              >
                Help Build a healthier tommorrow!
              </p>
              <Link
                id="about"
                to="/marketplace"
                className="btn btn-outline-warning rounded-pill"
                style={{
                  fontSize: "35px",
                  marginTop: 15,
                  fontFamily: '"Play", sans-serif',
                }}
              >
                Marketplace
              </Link>
            </span>

            {/* <img className="text-warning" src="https://i.imgur.com/7bze1J1.png" alt="logo for FitnessObsession" style={styles.logo}/> */}
          </div>
          <div  className="conts">
            <h1
              className="ofTitle text-warning"

            >
              ↓What We Offer↓
            </h1>
            <div className="contain">
              <div style={{ display: "grid" , margin: '4%'}}>
                <span>
                  <Link
                    className=" hoverLink btn btn-dark rounded-circle"
                    id="about"
                    to="/about"
                    style={styles.link}
                  >
                    <FontAwesomeIcon
                      className="text-warning iconImg"
                      icon={solid("circle-question")}
                      style={styles.bot}
                    />
                  </Link>
                </span>
                <label
                  htmlFor="about"
                  className="iconM text-warning"
                >
                  About
                </label>
              </div>
              <div style={{ display: "grid" , margin: '4%'}}>
                <span>
                  <Link
                    className=" hoverLink btn btn-dark rounded-circle"
                    id="Marketplace"
                    to="/marketplace"
                    style={styles.link}
                  >
                    <FontAwesomeIcon
                      className="text-warning iconImg"
                      icon={solid("gift")}
                      style={styles.bot}
                    />
                  </Link>
                </span>
                <label
                  htmlFor="Marketplace"
                  className="iconM text-warning"
                >
                  Marketplace
                </label>
              </div>

              <div style={{ display: "grid" , margin: '4%'}}>
                <span>
                  <Link
                    className="hoverLink btn btn-dark rounded-circle"
                    id="Reviews"
                    to="/reviews"
                    style={styles.link}
                  >
                    <FontAwesomeIcon
                      className="text-warning iconImg"
                      icon={solid("star-half-stroke")}
                      style={styles.bot}
                    />
                  </Link>
                </span>
                <label
                  htmlFor="Reviews"
                  className="iconM text-warning"
                >
                  Reviews
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const styles = {

  link: {
    position: "relative",
    cursor: "pointer",
    width: "20em",
    height: "20em",
    top: "10em",
  },
  bot: {
    position: "relative",
    top: "12.5%",
    cursor: "pointer",
    width: "14em",
    height: "14em",
  },
  logo: {
    opacity: "60%",
    width: "100%",
    zIndex: -1,

    backgroundColor: "#3D3D3D",
  },
};
